import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import config from '../../config';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { Button, Form, FieldCurrencyInput, FieldTextInput } from '../../components';
import css from './EditListingRelationshipsForm.module.css';

const { Money } = sdkTypes;

export const EditListingRelationshipsFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
      } = formRenderProps;

      const unitType = config.bookingUnitType;
      const isNightly = unitType === LINE_ITEM_NIGHT;
      const isDaily = unitType === LINE_ITEM_DAY;

      const translationKey = isNightly
        ? 'EditListingRelationshipsForm.pricePerNight'
        : isDaily
        ? 'EditListingRelationshipsForm.pricePerDay'
        : 'EditListingRelationshipsForm.pricePerUnit';

      const pricePerUnitMessage = intl.formatMessage({
        id: translationKey,
      });

      const pricePlaceholderMessage = intl.formatMessage({
        id: 'EditListingRelationshipsForm.priceInputPlaceholder',
      });

      const priceRequired = validators.required(
        intl.formatMessage({
          id: 'EditListingRelationshipsForm.priceRequired',
        })
      );
      const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
      const minPriceRequired = validators.moneySubUnitAmountAtLeast(
        intl.formatMessage(
          {
            id: 'EditListingRelationshipsForm.priceTooLow',
          },
          {
            minPrice: formatMoney(intl, minPrice),
          }
        ),
        config.listingMinimumPriceSubUnits
      );
      const priceValidators = config.listingMinimumPriceSubUnits
        ? validators.composeValidators(priceRequired, minPriceRequired)
        : priceRequired;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
      const { updateListingError, showListingsError } = fetchErrors || {};

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingRelationshipsForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingRelationshipsForm.showListingFailed" />
            </p>
          ) : null}
         <FieldTextInput
            id="owner"
            name="owner"
            className={css.description}
            type="textarea"
            label={'Owner'}
            placeholder={'Owner'}
            autoFocus
          />  


          <FieldTextInput
            id="propertyManager"
            name="propertyManager"
            className={css.description}
            type="textarea"
            label={'Property Manager'}
            placeholder={'Property Manager'}
          />  


        <FieldTextInput
            id="teacherFirstName"
            name="teacherFirstName"
            className={css.description}
            type="textarea"
            label={'Teacher (First Name)'}
            placeholder={'Teacher (First Name)'}
          />  

          <FieldTextInput
            id="teacherLastName"
            name="teacherLastName"
            className={css.description}
            type="textarea"
            label={'Teacher (Last Name)'}
            placeholder={'Teacher (Last Name)'}
          />  

          <FieldTextInput
            id="teacherSchool"
            name="teacherSchool"
            className={css.description}
            type="textarea"
            label={'Teacher (School)'}
            placeholder={'Teacher (School)'}
          />  

          <FieldTextInput
            id="teacherYearsAtOUSD"
            name="teacherYearsAtOUSD"
            className={css.description}
            type="textarea"
            label={'Teacher (Years at OUSD)'}
            placeholder={'Teacher (Years at OUSD)'}
          />  




          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingRelationshipsFormComponent.defaultProps = { fetchErrors: null };

EditListingRelationshipsFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingRelationshipsFormComponent);
